import React from 'react'
import MaterialSymbol from '../material-symbol'

const AccountTree = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="account_tree" {...props} />
))

AccountTree.displayName = 'AccountTree'

export default AccountTree
